import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import useParams from '@components/Hooks/useParams';
import Password from '@Shared/Forms/Password';
import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';

const SetPasswordForm: React.FC = () => {

  const [, dispatch] = useGlobalState();
  const api = useApi(dispatch);
  const params = useParams();

  const [new_password, setNewPassword] = useState<string>('');
  const [new_password2, setNewPassword2] = useState<string>('');

  const changePassword = (e: React.FormEvent) => {
    e.preventDefault();

    if (!params.email) {
      return showError('Missing valid email');
    }
    if (!params.token) {
      return showError('Missing valid security token');
    }
    if (!new_password) {
      return showError('Missing desired password');
    }
    if (!new_password2) {
      return showError('Missing second desired password');
    }
    if (new_password != new_password2) {
      return showError('Passwords do not match');
    }
    api.setPassword(params.email, params.token, new_password);
  }

  const showError = (message: string) => {
    dispatch({ type: 'DONE_CHANGE_PASSWORD', data: { result: '', _info: { success: false, message: message } } });
  }

  return (
    <form id='change-password-form' onSubmit={changePassword} className={api.isReallyLoading('changePassword') ? 'dim' : ''}>

      <Password name='new_password' title='Desired Password' value={new_password} setter={setNewPassword} required />
      <Password name='new_password2' title='Confirm Desired Password' value={new_password2} setter={setNewPassword2} required />

      <Form.Group style={{ marginTop: 19 }} className='form-group'>
        <Button variant='primary' type="submit" onClick={changePassword}>
          Change
        </Button>
      </Form.Group>
    </form>
  );
}

export default SetPasswordForm;